import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { VorgangFacade, VorgangResource } from '@schir-int-client/vorgang-shared';
import { Observable, withLatestFrom } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { getUrl } from '@ngxp/rest';
import { ApiRootFacade, ApiRootLinkRel } from '@schir-int-client/api-root';

@Component({
	selector: 'schir-int-client-verfuegungen-in-vorgang-container',
	templateUrl: './verfuegungen-in-vorgang-container.component.html',
	styleUrls: ['./verfuegungen-in-vorgang-container.component.scss'],
	host: { class: 'x-section' },
	standalone: false,
})
export class VerfuegungenInVorgangContainerComponent {
	vorgang: Observable<VorgangResource>;

	constructor(vorgangFacade: VorgangFacade, route: ActivatedRoute, apiRootFacade: ApiRootFacade) {
		this.vorgang = route.params.pipe(
			withLatestFrom(apiRootFacade.getCurrentApiRoot()),
			switchMap(([route, apiRoot]) => {
				vorgangFacade.loadVorgang(getUrl(apiRoot, ApiRootLinkRel.VORGANGS) + '/' + route['vorgangId']);
				return vorgangFacade.getSelectedVorgang();
			})
		);
	}
}
